import { Api } from "./Api";

export default {
    index() {
        return Api.get(`/v1/management/roles`);
    },
    show(role_id) {
        return Api.get(`/v1/management/roles/${role_id}`);
    },
    store(obj) {
        return Api.post(`/v1/management/roles`, obj);
    },
    update(role_id, obj) {
        return Api.put(`/v1/management/roles/${role_id}`, obj);
    },
    delete(role_id) {
        return Api.delete(`/v1/management/roles/${role_id}`);
    },
}